// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".refinement-btn{width:180px}.refinement-btn input[type=checkbox]{position:absolute;clip:rect(0, 0, 0, 0);pointer-events:none}.clear-refinement-btn{border:0px;white-space:nowrap;cursor:pointer;height:40px;border-radius:20px;padding:10px;background:#000;color:#fff}", ""]);
// Exports
module.exports = exports;
